import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import AddTabs from '../../../addTabs/AddTabs'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import SupplierAbout from './about/SupplierAbout'
import { getSupplierAPI } from '../../../../api/supply/supplierAPI'
import SupplierApproval from './approval/SupplierApproval'
import SupplierFiles from './files/SupplierFiles'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplier } from '../../../../store/supplierSlice'
import SupplierContacts from './contacts/SupplierContacts'

const SupplierView = ({ supplierId }) => {

    const supplier = useSelector(state => state.supplier.supplier)
    const dispatch = useDispatch()
    // const [supplier, setSupplier] = useState('')

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getSupplyOrder()
    }, [supplierId])

    const getSupplyOrder = () => {
        setLoading(true)

        getSupplierAPI({ supplierId }).then(data => {
            // setSupplier(data)
            dispatch(setSupplier(data))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='supplyOrderView'>
        <ErrorMessage error={error} />
        {
            !error ?
                <>
                    <div className='supplyOrderView__left'>
                        <div className='supplyOrderView__top'>
                            <SupplierAbout
                                supplier={supplier}
                            />
                            <SupplierApproval
                                supplier={supplier}
                            />
                        </div>
                        <div>
                            <SupplierContacts
                                supplier={supplier}
                            />
                        </div>
                        <div>
                            <SupplierFiles 
                                supplier={supplier}
                            />
                        </div>
                        {/* <SupplyOrderItems 
                            supplyOrderId={supplyOrderId}
                            supplyOrderItems={supplyOrder.items}
                        /> */}
                    </div>
                    <div className='supplyOrderView__right'>
                        <AddTabs
                            comments={supplier.comments}
                            changes={supplier.changes}
                            supplierId={supplierId}
                        />
                    </div>
                </>
            : ''
        }
    </div>
  )
}

export default SupplierView